export const ONLINE_UPGRADE_OFFER_ZERO_DOLLAR_ETF = '$0 ETF';
export const ONLINE_UPGRADE_OFFER_LOW_COST_TRIAL = 'Low Cost Trial';

export const PRO_PRODUCT_PACKAGE_TYPES = {
  SUBSCRIPTION: 'Subscription',
  PAY_PER_LEAD: 'Pay Per Lead',
  OPPORTUNITIES_ONLY: 'Opportunities Only',
};



// WEBPACK FOOTER //
// ./src/modules/common/commonConstants.js